import { preloadImage } from '../lib/imageCache';

type SuspendedImageProps = {
    src: string;
    alt: string;
    imageStyle: React.CSSProperties;
};

export const SuspendedImage = ({
    src,
    alt,
    imageStyle,
}: SuspendedImageProps) => {
    preloadImage(src);
    return (
        <img
            src={src}
            alt={alt}
            style={imageStyle}
            className="mx-auto block select-none"
            draggable={false}
        />
    );
};
